import Vue from 'vue'

export const events = new Vue({
  name: 'vue-confirm-dialog'
})



// WEBPACK FOOTER //
// ./src/events.js